import React, { useEffect, useMemo, useState } from "react";
import httpClient from "../../components/helpers/httpClient";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

export default function MobileCompaniesList({ onOpenCompany }) {
  const [loading, setLoading] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [searchWord, setSearchWord] = useState("");
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const limit = 30;

  const requestData = useMemo(
    () => ({
      filters: {
        city: "",
        search_word: searchWord,
      },
      sort: "id",
      sortAscending: true,
    }),
    [searchWord]
  );

  const fetchCompanies = async () => {
    setLoading(true);
    try {
      const response = await httpClient.post(
        import.meta.env.VITE_API_URL +
          `/api/companies/get?page=${page}&limit=${limit}`,
        requestData
      );
      const list = Array.isArray(response?.data?.[0]) ? response.data[0] : [];
      const pages = typeof response?.data?.[1] === "number" ? response.data[1] : 1;
      setCompanies(list);
      setTotalPages(pages);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCompanies();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, requestData]);

  const handleClear = () => {
    if (searchWord === "") return;
    setSearchWord("");
    setPage(1);
  };

  return (
    <div className="mobile-list">
      <div className="mobile-search" onClick={handleClear}>
        <SearchIcon style={{ color: "var(--secondairy-medium-gray)" }} />
        <input
          placeholder="Search company..."
          value={searchWord}
          onChange={(e) => {
            setSearchWord(e.target.value);
            setPage(1);
          }}
        />
        {searchWord === "" ? null : <ClearIcon />}
      </div>

      {loading ? (
        <div style={{ padding: "8px 4px", color: "var(--secondairy-medium-gray)" }}>
          Loading...
        </div>
      ) : companies.length === 0 ? (
        <div style={{ padding: "8px 4px", color: "var(--secondairy-medium-gray)" }}>
          No companies found.
        </div>
      ) : (
        companies.map((c) => {
          const title = c?.company_name || `Company #${c?.id}`;
          const subtitle = [c?.city, c?.email].filter(Boolean).join(" • ");
          return (
            <button
              key={c.id}
              type="button"
              className="mobile-row"
              onClick={() => onOpenCompany?.(c.id)}
              style={{ cursor: "pointer", border: "none", textAlign: "left" }}
            >
              <div>
                <div className="mobile-row__title">{title}</div>
                <div className="mobile-row__subtitle">{subtitle}</div>
              </div>
              <div className="mobile-row__right">
                <ChevronRightIcon />
              </div>
            </button>
          );
        })
      )}

      <div
        style={{
          display: "flex",
          gap: 10,
          justifyContent: "space-between",
          alignItems: "center",
          padding: "6px 2px",
          color: "var(--secondairy-medium-gray)",
        }}
      >
        <button
          type="button"
          disabled={page <= 1}
          onClick={() => setPage((p) => Math.max(1, p - 1))}
          style={{
            padding: "10px 12px",
            borderRadius: 12,
            border: "1px solid var(--mobile-border)",
            background: "var(--mobile-card)",
            opacity: page <= 1 ? 0.5 : 1,
          }}
        >
          Prev
        </button>
        <div>
          Page {page} / {totalPages}
        </div>
        <button
          type="button"
          disabled={page >= totalPages}
          onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
          style={{
            padding: "10px 12px",
            borderRadius: 12,
            border: "1px solid var(--mobile-border)",
            background: "var(--mobile-card)",
            opacity: page >= totalPages ? 0.5 : 1,
          }}
        >
          Next
        </button>
      </div>
    </div>
  );
}


